var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery-view",on:{"click":function($event){return _vm.$store.commit('gallery', [])}}},[_c('div',{class:{
		detail: true,
		flipped: _vm.flip
	},style:({
		backgroundImage: `url('${_vm.url}')`
	})},[_c('div',{staticClass:"arrow left",on:{"click":function($event){$event.stopPropagation();return _vm.prev()}}},[_vm._v("<")]),_c('div',{staticClass:"arrow right",on:{"click":function($event){$event.stopPropagation();return _vm.next()}}},[_vm._v(">")])]),_c('div',{class:{
		list: true,
		flipped: _vm.flip
	}},_vm._l((_vm._items),function(p,i){return _c('div',{key:i,staticClass:"thumb",style:({
			backgroundImage: 'url(' + p.url + ')'
		}),on:{"click":function($event){$event.stopPropagation();return _vm.open(i)}}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }